<template>
  <main-layout
    class="pb-4"
    wide
  >
    <div>
      <base-breadcrumb :routes="routes" />
      <base-card
        v-if="!stateIsLoading"
        class=""
      >
        <div class="row">
          <div class="col">
            <base-heading class="mb-3 pl-3 d-flex align-items-center justify-content-between">
              <div>
                <span class="lh-lg align-middle">Activity</span>
              </div>
              <div class="search-bar">
                <base-search
                  :value="search"
                  @input="onSearch"
                />
              </div>
            </base-heading>

            <div class="p-4">
              <div class="row">
                <div class="col-3">
                  <p class="column-header pr-24">
                    CLIENT
                  </p>
                </div>
                <div class="col-3">
                  <p class="column-header">
                    CLIENT EMAIL
                  </p>
                </div>
                <div class="col-4" />

                <!-- /*  PLACE FOR 'OPENS' TAB */ -->
                <div class="col-1 d-flex justify-content-center">
                  <p class="column-header" />
                </div>
                <!-- /*  PLACE FOR 'OPENS' TAB */ -->

                <div class="col-1 d-flex justify-content-center">
                  <p class="column-header">
                    STATUS
                  </p>
                </div>
              </div>
              <div
                v-for="(client, index) in clientsToDisplay"
                :key="client.customer.pk"
                class="row top-buffer"
                :class="index != Object.keys(clientsToDisplay).length - 1 ? 'border-bottom' : ''"
              >
                <div class="col-3">
                  <p class="column-cell">
                    {{ client.customer.first_name + " " + client.customer.last_name }}
                  </p>
                </div>
                <div class="col-3">
                  <p class="column-cell">
                    {{ client.customer.email }}
                  </p>
                </div>
                <div class="col-4" />

                <!-- /*  PLACE FOR 'OPENS' TAB */ -->
                <div class="col-1 d-flex justify-content-center">
                  <p class="column-cell" />
                </div>
                <!-- /*  PLACE FOR 'OPENS' TAB */ -->

                <div class="col-1 d-flex justify-content-center">
                  <p class="column-cell">
                    {{ type }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </base-card>
    </div>
  </main-layout>
</template>

<script>
export default {
  name: 'GuestReport',
  data() {
    return {
      search: '',
      stateIsLoading: true,
      clientsToDisplay: [],
    };
  },
  computed: {
    invitees() {
      if (Object.keys(this.item).length === 0 || this.item.invitations === undefined) {
        return [];
      }
      return this.item.invitations.filter((item) => item.customer !== null);
    },
    clients() {
      return this.invitees.filter((item) => item.status === this.guestGroup);
    },
    item() {
      return this.$store.state.appointments.item;
    },

    routes() {
      return [{
        name: 'Appointments',
        link: '/appointments',
      }, {
        name: this.item.subject,
        link: `/appointments/${this.item.pk}/view`,
      }, {
        name: this.type,
      }];
    },
    appointmentId() {
      return this.$route.params.id;
    },
    type() {
      return this.$route.params.type;
    },
    guestGroup() {
      return this.type === 'Pending' ? 'PE'
        : this.type === 'Declined' ? 'DE'
          : this.type === 'Confirmed' ? 'CO'
            : '';
    },
  },
  watch: {
    clients: {
      handler(newval) {
        this.clientsToDisplay = newval;
      },
    },
  },
  mounted() {
    this.fetchItem();
  },
  methods: {
    onSearch(evt) {
      const subStr = evt.toLowerCase();
      this.clientsToDisplay = this.clients.filter((c) => {
        if (c.customer.first_name.toLowerCase().includes(subStr)
        || c.customer.last_name.toLowerCase().includes(subStr)
        || c.customer.email.toLowerCase().includes(subStr)) {
          return true;
        }
        return false;
        // if (c.includes(evt))
      });
    },
    status(msg) {
      console.log(msg);
    },
    fetchItem() {
      this.$store.dispatch('appointments/getItem', this.appointmentId).then((data) => {
        this.stateIsLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
p {
  margin: 0;
}
.column-header {
    /* Silka/12px/Regular */

  font-family: 'SilkaRegular';
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  /* identical to box height, or 133% */

  /* Grey/#AAAAAA */

  color: #AAAAAA;

}
.column-cell {
    /* Silka/14px/Regular */

  font-family: 'SilkaLight';
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  /* identical to box height, or 114% */

  display: flex;
  align-items: center;

  color: #333333;

}
.search-bar {
  margin-left: auto;

  &::v-deep input {
    min-width: 310px;
    min-height: 42px;
    font-size: 0.875rem;
  }
}
.top-buffer {
  padding-top: 29px;
  padding-bottom: 26px;
}
</style>
